import { inject, Injectable } from "@angular/core";
import { LocalStorageService } from "../../../shared/services/local-storage.service";
import { PlanningSourceKey } from "../utils/source-key";

export interface PlanningPrefs {
  mode: "bullet" | "list";
  cellCount: number;
  todayOffset: number;
  comfortable: boolean;
  /**
   * Nombre de jours avant `dateDebut` pour afficher l'event "Préparer PDC"
   * généré par `pdcToPlanningEvents`. Défaut 1 (veille du lancement).
   */
  pdcPrepaOffsetDays: number;
  /**
   * Liste des clés de source à masquer dans le planning (filtre multi-select
   * du menu réglages). Vide = toutes les sources sont visibles.
   */
  hiddenSources: PlanningSourceKey[];
}

const DEFAULTS: PlanningPrefs = {
  mode: "list",
  cellCount: 5,
  todayOffset: 1,
  comfortable: true,
  pdcPrepaOffsetDays: 1,
  hiddenSources: [],
};

const STORAGE_PREFIX = "pl-prefs-";

@Injectable({ providedIn: "root" })
export class PlanningPrefsService {
  private localStorage = inject(LocalStorageService);

  load(persistenceKey: string): PlanningPrefs {
    if (!persistenceKey) return { ...DEFAULTS };
    const stored = this.localStorage.getWithTTL(STORAGE_PREFIX + persistenceKey);
    if (!stored) return { ...DEFAULTS };
    return { ...DEFAULTS, ...stored };
  }

  save(persistenceKey: string, partial: Partial<PlanningPrefs>): void {
    if (!persistenceKey) return;
    const current = this.load(persistenceKey);
    const merged = { ...current, ...partial };
    this.localStorage.putWithTTL(
      STORAGE_PREFIX + persistenceKey,
      merged,
      365 * 24 * 3600,
    );
  }
}
